export function convertDriveLink(url: string): string {
  if (!url) return url;
  if (url.includes("drive.google.com")) {
    const fileMatch = url.match(/\/file\/d\/([^\/]+)/);
    if (fileMatch) {
      return `https://drive.google.com/thumbnail?id=${fileMatch[1]}&sz=w1000`;
    }
    const idMatch = url.match(/[?&]id=([^&]+)/);
    if (idMatch) {
      return `https://drive.google.com/thumbnail?id=${idMatch[1]}&sz=w1000`;
    }
  }
  return url;
}
